import { render, staticRenderFns } from "./AddDiscountCategoryModal.vue?vue&type=template&id=96ee1208&scoped=true"
import script from "./AddDiscountCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddDiscountCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ee1208",
  null
  
)

export default component.exports